import { render } from "./StatsBuilderFilters.vue?vue&type=template&id=63edfb96&scoped=true"
import script from "./StatsBuilderFilters.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderFilters.vue?vue&type=script&lang=ts"

import "./StatsBuilderFilters.vue?vue&type=style&index=0&id=63edfb96&lang=scss"
import "./StatsBuilderFilters.vue?vue&type=style&index=1&id=63edfb96&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-63edfb96"

export default script